export default __webpack_public_path__ + "static/media/9.6cce29d6.gif";